// extracted by mini-css-extract-plugin
module.exports = {"main_sign":"sign_main_sign__1UErl","upper":"sign_upper__3sLKK","divide":"sign_divide__3RjSh","lin":"sign_lin__txtHj","sig_botm":"sign_sig_botm__25tAa"};